import ImgArticle from './ImgArticle';
import DescArticle from './DescArticle';
import ButtonCounter from './ButtonCounter';
import useSuggestHandler from '../../../../redux/handler/useSuggestHandler';
import { Link } from 'react-router-dom';
import { styled } from '@material-ui/core';

const CartArticle = ({ producto, cantidadEnCarrito }) => {

  const { handlerCloseModal } = useSuggestHandler();

  const handlerOpenProduct = () => {
    handlerCloseModal();
  };

  return (
    <Content onClick={handlerOpenProduct} to={"/precios_stock_detallado/" + producto.Codigo}>
      <Box>
        <ImgArticle producto={producto}/>
        <DescArticle producto={producto}/>
      </Box>
      <ButtonCounter producto={producto} cantidad={cantidadEnCarrito} />
    </Content>
  )
}

const Box = styled('div')({
  display: 'flex',
  gap: '25px',
});

const Content = styled(Link)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '40px',
  '@media (max-width: 1200px)' : {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '10px',
  },
  '&:hover': {
    textDecoration: 'none'
  },
  '&:focus': {
    textDecoration: 'none'
  }
});

export default CartArticle;
